import type { AxiosRequestConfig } from 'axios'
import axios from 'axios'

export async function apiClient(endpoint: string, {
  requireAuth = true,
  ...requestOptions
}: AxiosRequestConfig & { requireAuth?: boolean }) {
  const token = localStorage.getItem('token')
  if (requireAuth && !token) {
    const details = { endpoint, error: 'You are not logged in, please log in and try again' }
    console.error(details)
    // TODO: we can explicitly redirect the user to the login page, or reset the state, etc.
    return Promise.reject(new Error(details.error))
  }

  return axios({
    baseURL: import.meta.env.DEV ? 'http://localhost:4000' : '',
    url: endpoint,
    method: requestOptions.method ?? 'GET',
    withCredentials: true,
    ...requestOptions,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...(requestOptions?.headers || {}),
      ...(requireAuth ? { Authorization: token } : {}),
    },
  })
}
